import React from 'react';
import Loadable from 'react-loadable';

import { CONCEPTS } from '@rover/rsdk/src/concepts';
import retry from '@rover/rsdk/src/modules/Network/retry';
import Route from '@rover/types/src/Route';

import Loading from '../client/Loading';

const FixturesPage = Loadable({
  loader: (): Promise<React.ComponentType> =>
    retry(() =>
      import(
        /* webpackChunkName: "FixturesPage" */
        '@rover/react-lib/src/pages/fixtures/FixturesPage'
      ).then((module) => module.default as React.ComponentType)
    ),
  loading: Loading,
});

const BuildPage = Loadable({
  loader: (): Promise<React.ComponentType> =>
    retry(() =>
      import(
        /* webpackChunkName: "BuildsPage" */
        '@rover/react-lib/src/pages/fixtures/BuildPage'
      ).then((module) => module.default as React.ComponentType)
    ),
  loading: Loading,
});

const BuildsPage = Loadable({
  loader: (): Promise<React.ComponentType> =>
    retry(() =>
      import(
        /* webpackChunkName: "BuildsPage" */
        '@rover/react-lib/src/pages/fixtures/BuildsPage'
      ).then((module) => module.default as React.ComponentType)
    ),
  loading: Loading,
});

const TemplatesPage = Loadable({
  loader: (): Promise<React.ComponentType> =>
    retry(() =>
      import(
        /* webpackChunkName: "TemplatesPage" */
        '@rover/react-lib/src/pages/fixtures/TemplatesPage'
      ).then((module) => module.default as React.ComponentType)
    ),
  loading: Loading,
});

const TemplatePage = Loadable({
  loader: (): Promise<React.ComponentType> =>
    retry(() =>
      import(
        /* webpackChunkName: "TemplatePage" */
        '@rover/react-lib/src/pages/fixtures/TemplatePage'
      ).then((module) => module.default as React.ComponentType)
    ),
  loading: Loading,
});

const TemplateRunPage = Loadable({
  loader: (): Promise<React.ComponentType> =>
    retry(() =>
      import(
        /* webpackChunkName: "TemplateRunPage" */
        '@rover/react-lib/src/pages/fixtures/TemplatePage'
      ).then((module) => module.TemplateRunPage as React.ComponentType)
    ),
  loading: Loading,
});

const WebhooksPage = Loadable({
  loader: (): Promise<React.ComponentType> =>
    retry(() =>
      import('@rover/react-lib/src/pages/fixtures/WebhooksPage').then(
        (module) => module.default as React.ComponentType
      )
    ),
  loading: Loading,
});

const WebhookPage = Loadable({
  loader: (): Promise<React.ComponentType> =>
    retry(() =>
      import('@rover/react-lib/src/pages/fixtures/WebhookPage').then(
        (module) => module.default as React.ComponentType
      )
    ),
  loading: Loading,
});

const StepsRunPage = Loadable({
  loader: (): Promise<React.ComponentType> =>
    retry(() =>
      import(
        /* webpackChunkName: "StepsRunPage" */
        '@rover/react-lib/src/pages/fixtures/StepsRunPage'
      ).then((module) => module.default as React.ComponentType)
    ),
  loading: Loading,
});

export const FIXTURES_PATH = '/dev/fixtures/';
export const FIXTURES_BUILD_PATH = '/dev/fixtures/builds/:id';
export const FIXTURES_BUILDS_PATH = '/dev/fixtures/builds';
export const FIXTURE_WEBHOOKS_PATH = '/dev/fixtures/webhooks';
export const FIXTURE_WEBHOOK_PATH = '/dev/fixtures/webhooks/:slug';
export const FIXTURE_TEMPLATES_PATH = '/dev/fixtures/templates';
export const FIXTURES_TEMPLATE_PATH = '/dev/fixtures/templates/:slug';
export const FIXTURES_TEMPLATE_RUN_PATH = '/dev/fixtures/templates/:slug/run';
export const FIXTURE_STEPS_RUN_PATH = '/dev/fixtures/steps-run';

const routes: Route[] = [
  {
    path: FIXTURES_PATH,
    component: FixturesPage,
    componentName: 'FixturesPage',
    exact: true,
    cacheTag: ['page-fixtures'],
    pageName: 'ssr-fixtures',
  },
  {
    path: FIXTURES_BUILD_PATH,
    component: BuildPage,
    componentName: 'BuildPage',
    exact: true,
    cacheTag: ['page-fixtures-build'],
    pageName: 'ssr-fixtures-build',
  },
  {
    path: FIXTURES_TEMPLATE_PATH,
    component: TemplatePage,
    componentName: 'FixturePage',
    exact: true,
    cacheTag: ['page-fixture'],
    pageName: 'ssr-fixture',
  },
  {
    path: FIXTURES_TEMPLATE_RUN_PATH,
    component: TemplateRunPage,
    componentName: 'FixtureRunPage',
    exact: true,
    cacheTag: ['page-fixture'],
    pageName: 'ssr-fixture-run',
  },
  {
    path: FIXTURES_BUILDS_PATH,
    component: BuildsPage,
    componentName: 'FixturesBuildsPage',
    exact: true,
    cacheTag: ['page-fixtures-builds'],
    pageName: 'ssr-fixtures',
  },
  {
    path: FIXTURE_TEMPLATES_PATH,
    component: TemplatesPage,
    componentName: 'TemplatesPage',
    exact: true,
    cacheTag: ['page-fixtures-templates'],
    pageName: 'ssr-fixtures-templates',
  },
  {
    path: FIXTURE_WEBHOOKS_PATH,
    component: WebhooksPage,
    componentName: 'WebhooksPage',
    exact: true,
    cacheTag: ['page-fixtures-webhooks'],
    pageName: 'ssr-fixtures-webhooks',
  },
  {
    path: FIXTURE_WEBHOOK_PATH,
    component: WebhookPage,
    componentName: 'WebhookPage',
    exact: true,
    cacheTag: ['page-fixture-webhook'],
    pageName: 'ssr-fixture-webhook',
  },
  {
    path: FIXTURE_STEPS_RUN_PATH,
    component: StepsRunPage,
    componentName: 'StepsRunPage',
    exact: true,
    cacheTag: ['page-fixtures-steps-run'],
    pageName: 'ssr-fixtures-steps-run',
  },
].map((route) => ({
  ...route,
  pageCategory: 'ssr-fixtures',
  concept: CONCEPTS.platform.development,
  suppressHeader: true,
  suppressFooter: true,
  cacheTag: [...route.cacheTag, 'page-all'],
  isReactQueryRoute: true,
}));

export default routes;
